
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import { SessionMgmtService } from '../session-mgmt/session-mgmt.service';
import { ToastService } from '../toast/toast.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { APP_CONST } from '../../constants/app-constants';
import { ManagersService } from '../managers/managers.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  linktoRedirect: string = "";
  redirectParams: any = {} 
  constructor(
    public _utilService: UtilsService,
    private _sessionMgmtService: SessionMgmtService,
    private _toast: ToastService,
    private _router: Router,
    private _managersService: ManagersService
  ) { }

  token?: string;

  validateEmail(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.validateEmail);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred in validateEmail:', error);
      // Add your error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // You can customize the error message as needed
    }
  }

  validateUserPassword(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.validateUserPassword);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred in validatePassword:', error);
      // Add error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // We can customize the error message as needed
    }
  }

  validatePassword(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.validate_password);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred in validate_user_password:', error);
      // Add error handling logic for unexpected errors here
      return throwError('An unexpected error occurred in validate_user_password'); // We can customize the error message as needed
    }
  }

  forgetPassword(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.forget_password);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred in validate_user_password:', error);
      // Add error handling logic for unexpected errors here
      return throwError('An unexpected error occurred in validate_user_password'); // We can customize the error message as needed
    }
  }
  resendOtp(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.resendOtp);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaderWithParams({}))
    } catch (error) {
      console.error('An unexpected error occurred in resendOtp:', error);
      // Add error handling logic for unexpected errors here
      return throwError('An unexpected error occurred in resendOtp'); // We can customize the error message as needed
    }
  }
  resetPassword(reqBody, queryParams) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.reset_password);

      return this._utilService.postAPICall(url, reqBody, {
        headers: this._utilService.setHeaders(),
        params: queryParams // Pass query parameters
      });
    } catch (error) {
      console.error('An unexpected error occurred in resetPassword:', error);
      // Add error handling logic for unexpected errors here
      return throwError('An unexpected error occurred in resetPassword'); // We can customize the error message as needed
    }
  }

  redirectToHome() {
    const redirectDetails = this.getRedirectDetails()
    if (redirectDetails.linktoRedirect && redirectDetails.linktoRedirect != "") {
      this.gotoRedirectionPage();
    } else {
      this.gotoAccounts()
    }
  }

  redirectBasedOnAccess(manager: any){
    this._managersService.getAccess(manager, {
      gotoProject: (accountId, projectId) => this.gotoProject(accountId, projectId),
      gotoDashboard: (accountId) => this.gotoDashboard(accountId),
      gotoAccounts: () => this.gotoAccounts(),
      logoutUser: () => this.logoutUser(),
      setError: (msg) => {},
      setShowLoader: (val) => {},

    });
  }

  gotoProject(accountId: string, projectId: string, activeTab: string = 'trends') {
    this._router.navigate([APP_CONST.ROUTE_PROJECT_DETAILS], {
      queryParams: {
        account_id: accountId,
        project_id: projectId,
        active_tab: activeTab
      }
    });
  }

  gotoDashboard(accountId: string) {
    this._router.navigate([APP_CONST.ROUTE_ACCOUNT_DETAILS], {
      queryParams: { account_id: accountId }
    });
  }

  logoutUser() {
    try {
      const reqBody = {};
      this.logoutUserApi(reqBody).subscribe(
        (response) => {
          // Additional cleanup logic
        },
        (error) => {
          console.error('Error in API call in logout:', error);
        }
      );
    } catch (error) {
      console.error('Error occurred in logout:', error);
    }
  }

  // gotoAccounts() {
  //   this._router.navigate([APP_CONST.ROUTE_ACCOUNTS]);
  // }
  // gotoLogin() {
  //   this._router.navigate([APP_CONST.ROUTE_LOGIN]);
  // }


  gotoAccounts() {
    this._router.navigate([APP_CONST.ROUTE_ACCOUNTS]);
  }
  gotoLogout() {
    this._router.navigate([APP_CONST.ROUTE_LOGOUT]);
  }
  gotoLogin(redirect?: { redirectUrl: string, redirectParams: any }) {
    if (!_.isEmpty(redirect) && _.hasIn(redirect, 'redirectUrl')) {
      this.linktoRedirect = _.get(redirect, 'redirectUrl', '');
      this.redirectParams = _.get(redirect, 'redirectParams', []);
    }
    console.log("redirect", redirect)
    this._router.navigate([APP_CONST.ROUTE_LOGIN]);
  }
  getRedirectDetails() {
    return {
      linktoRedirect: this.linktoRedirect,
      redirectParams: this.redirectParams
    }
  }

  gotoRedirectionPage() {
    this._router.navigate([this.linktoRedirect], { queryParams: this.redirectParams });
    this.linktoRedirect = "";
    this.redirectParams = {}
  }

  getManagerDetails() {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.me);
    const params = {
      'tmp': new Date().getTime()
    };
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }

  // Call this API to check the loggedIn or not
  checkUserIsLoggedIn() {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.me);
    const params = {
      'tmp': new Date().getTime()
    };
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }


  checkLogin() {
    try {
      this.checkUserIsLoggedIn().subscribe(
          (response) => {
            if (response.code === 0) {
              const isManagerLoggedIn = response.data && response.data.isManagerLoggedIn;
              const loginNotAllowed = response.data && response.data.manager && response.data.manager.is_only_promoter_user == true;
              if (!loginNotAllowed && isManagerLoggedIn) {
                this._sessionMgmtService.setData('selectedEn', 'null');
                this._sessionMgmtService.setData("LOGIN_RESPONSE", JSON.stringify(response.data));
                this.checkAccess(response.data.manager);
              } else {
                // if (response.data.code == 403 && response.data.error_message != null) {
                //     const message = "You are trying to access the dashboard through an invalid IP address which is not authorized. Kindly contact your company's administrator";
                //     if (loginResponse.data.error_data && (loginResponse.data.error_data.x_client_ip || loginResponse.data.error_data['x-real-ip'])) {
                //         message = "You are trying to access the dashboard through the "+(loginResponse.data.error_data.x_client_ip || loginResponse.data.error_data['x-real-ip'])+" IP address which is not authorized. Kindly contact your company's administrator.";
                //     }
                //     $("#verificationError").html("<img class='ltms-dasboard-login-info-icon' src='img/info-icon.svg'>&nbsp; <span class='ltms-dashboard-login-error-message'>"+message+"</span>");
                //     $("#verificationError").show();
                // }
              }
            }
          },
          (error) => {
            console.error('Error in API call in CheckLogin:', error);
          }
        );
    } catch (error) {
      console.error('Error occurred in CheckLogin:', error);
      // Add your error handling logic for unexpected errors here
    }
  }

  // Call this API to update logout time
  updateLogoutTime() {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.updateLogoutTime);
    const params = {};
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }

  update_logout_time() {
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.updateLogoutTime);
      this._utilService.getAPICall(url, this._utilService.setHeaderWithParams({}))
        .subscribe(
          (response) => {
            if (response && response.code === 0 && response.data && response.data.code === 0) {
              // Update last_login_update_time with current time
              const currentTime = new Date().toISOString();
              this._sessionMgmtService.setData('last_login_update_time', currentTime);
            } else {
              this.gotoLogin()
            }
          },
          (error) => {
            console.error('Error in API call in update logout time:', error);
            this.gotoLogin()
          }
        );
    } catch (error) {
      console.error('Error occurred in update log out time:', error);
    }
  }

  logoutUserApi(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.logout);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred in Logout:', error);
      // Add your error handling logic for unexpected errors here
      return throwError('An unexpected error occurred in Logout'); // You can customize the error message as needed
    }
  }

  logout(redirect?: { redirectUrl: string, redirectParams: any }) {
    try {
      let reqBody = {}
      if (!_.isEmpty(redirect) && _.hasIn(redirect, 'redirectUrl')) {
        this.linktoRedirect = _.get(redirect, 'redirectUrl', '');
        this.redirectParams = _.get(redirect, 'redirectParams', []);
      }
      this.logoutUserApi(reqBody).subscribe(
        (response) => {
          Helpers.resetAppState('full_reset');
          this.gotoLogout();
          this._sessionMgmtService.removeData('IS_SINGLE_EN_USER');
          this._sessionMgmtService.removeData('QUERY_PARAM_OBJ');
          this._sessionMgmtService.removeData('LtMsAcTiDfR');
          this._sessionMgmtService.removeData('LOGIN_RESPONSE');
        },
        (error) => {
          console.error('Error in API call in logout:', error);
        }
      );
    } catch (error) {
      console.error('Error occurred in update log out time:', error);
    }
  }
  checkAccess(manager) {
    if (manager && manager._id) {
      if (manager && manager.manager_access && manager.manager_access.length) {

        const managerAccess = this.getManagerAccess(manager.manager_access);

        // to check manager access is verified or not.
        if (manager.manager_access.length == 1 && manager.manager_access[0].manager_type && manager.manager_access[0].manager_type != 3) {
          // Not allowing user to access dashboard if "has_dashboard_access" is set to false
          const hasDashboardAccess = ("has_dashboard_access" in manager.manager_access[0]) ? manager.manager_access[0]["has_dashboard_access"] : true;
          if (hasDashboardAccess && manager.manager_access[0].is_verified) {

            this._sessionMgmtService.setData('isAccount', 'true');
            this._sessionMgmtService.setData('IS_SINGLE_EN_USER', 'true');
            this._sessionMgmtService.setData('QUERY_PARAM_OBJ', JSON.stringify(manager.manager_access[0]));
            this.redirectToHome()
            this._toast.showPopup('SUCCESS', 'Success', 'You are logged in successfully.', 2000)
          } else {
            // gotoLogin();
          }
        } else if (manager.manager_access.length == 1 && manager.manager_access[0].is_verified && manager.manager_access[0].manager_type && manager.manager_access[0].manager_type == 3) {
          this._sessionMgmtService.setData('IS_SINGLE_EN_USER', 'false');
          this._sessionMgmtService.setData('LtMsAcTiDfR', manager.manager_access[0].account_id);
          this._sessionMgmtService.setData('isAccount', 'true');
          // this.gotoBrand()
        } else if ((managerAccess.brandsWithAccount.length > 0 && managerAccess.brandsWithoutAccount.length > 0) || managerAccess.brandsWithAccount.length > 1) {
          this._sessionMgmtService.setData('IS_SINGLE_EN_USER', 'false');
          // this.gotoDashboard();
          this.redirectToHome()
          this._toast.showPopup('SUCCESS', 'Success', 'You are logged in successfully.', 2000)
        } else if (managerAccess.brandsWithAccount.length == 1) {
          this._sessionMgmtService.setData('IS_SINGLE_EN_USER', 'false');
          this._sessionMgmtService.setData('LtMsAcTiDfR', managerAccess.brandsWithAccount[0]);
          this._sessionMgmtService.setData('isAccount', 'true');
          this.redirectToHome()
          this._toast.showPopup('SUCCESS', 'Success', 'You are logged in successfully.', 2000)
          // this.gotoDashboard();
        } else {
          this._sessionMgmtService.setData('IS_SINGLE_EN_USER', 'false');
          this._sessionMgmtService.setData('isAccount', 'true');
          this.redirectToHome()
          this._toast.showPopup('SUCCESS', 'Success', 'You are logged in successfully.', 2000)
          // this.gotoDashboard();
        }

      } else {
        this.gotoLogin();
        // $("#verificationError").html("<img class='ltms-dasboard-login-info-icon' src='img/info-icon.svg'>&nbsp; <span class='ltms-dashboard-login-error-message'>You don't have access for any project, please contact the System Administrator</span>");
        // $("#verificationError").show();
        //            checkValidationType();
      }
    }
  }

  getManagerAccess(managerDetails) {
    const brandsWithoutAccount: any = [];
    const brandsWithAccount: any = [];
    managerDetails.forEach(function (access) {
      // To check manager access is verified or not.
      if (access && !access.account_id && access.is_verified) {
        brandsWithoutAccount.push(access);
      }
      if (access && access.account_id && access.is_verified) {
        brandsWithAccount.push(access);
      }
    });
    return {
      brandsWithoutAccount: brandsWithoutAccount,
      brandsWithAccount: _.uniq(_.map(brandsWithAccount, "account_id"))
    }
  }
}
